import React from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownTextProps {
  children: string | null | undefined;
  className?: string;
  emptyFallback?: React.ReactNode;
}

/**
 * Renders a markdown-formatted description field (bold/italic/lists/links).
 * react-markdown never executes raw HTML, so this is safe to render
 * directly without a separate sanitization step. Pair with
 * <RichTextEditor> wherever the value is edited.
 */
export default function MarkdownText({ children, className = '', emptyFallback = null }: MarkdownTextProps) {
  if (!children || !children.trim()) return <>{emptyFallback}</>;
  return (
    <div className={`markdown-text ${className}`}>
      <ReactMarkdown>{children}</ReactMarkdown>
    </div>
  );
}
